import * as THREE from "three";

// Sizes
export const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

// Canvas
export const canvas = document.querySelector("canvas.webgl");

export const planeSettings = {
  side: 2,
};

export const debugObject = {
  uPlaneColor: new THREE.Color("#f1eae6"),
  uMiddleColor: new THREE.Color("#aca6ce"),
  uDepthColor: new THREE.Color("#736495"),
  texture: "./textures/japan_polygons_small.png",
  textureVector: "./textures/japan_vector_stroke.jpg",
};

export const removeMeshFromScene = (scene) => {
  scene.traverse((object) => {
    if (object instanceof THREE.Mesh) {
      scene.remove(object);
    }
  });
};
